module.exports = __webpack_public_path__ + "static/media/placeholder.fe7aaf94.png";